var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDiamanteSelo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85449 1.78795C4.28639 1.45546 4.50234 1.28922 4.7516 1.18215C4.86461 1.13361 4.98212 1.09438 5.10273 1.06494C5.36874 1 5.65081 1 6.21494 1H9.78441C10.3485 1 10.6306 1 10.8966 1.06494C11.0172 1.09438 11.1347 1.13361 11.2478 1.18215C11.497 1.28922 11.713 1.45546 12.1449 1.78795C13.576 2.88966 14.2915 3.44051 14.5368 4.15385C14.6459 4.47115 14.6867 4.80486 14.6569 5.13641C14.5898 5.88178 14.025 6.56397 12.8952 7.92834L10.2329 11.1435C9.20806 12.3812 8.69564 13 7.99967 13C7.3037 13 6.79129 12.3812 5.76646 11.1435L3.10415 7.92833C1.97439 6.56397 1.40952 5.88178 1.34248 5.13641C1.31266 4.80486 1.35343 4.47115 1.46254 4.15385C1.70784 3.44051 2.42339 2.88966 3.85449 1.78795Z",
    stroke: "#33CAE3",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 4.66699H9.33317",
    stroke: "#33CAE3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiamanteSelo);
export default __webpack_public_path__ + "static/media/icon-diamante-selo.74498f124f0978866e00bc78a0f9d523.svg";
export { ForwardRef as ReactComponent };